// extracted by mini-css-extract-plugin
module.exports = {"tableValue":"styles_tableValue__3VY4d","inactiveRow":"styles_inactiveRow__1c2SS","labelActive":"styles_labelActive__1nppu","labelInactive":"styles_labelInactive__Okxvk"};